import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import StringTextField from 'src/components/widgets/string-textfield';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import useMediaQuery from '@mui/material/useMediaQuery';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import { DropdownStatus } from 'src/components/dropdown/dropdown-status';
import {
  initialValues,
  validationSchema,
  handleSubmitted,
} from './formik';


export const DetailForm = ({ item, myId, apiCreate, apiUpdate, apiDelete }) => {
  const mdUp = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const formik = useCustomFormik({
    initialValues,
    validationSchema: validationSchema(myId),

    onSubmit: async (values, helpers) => {
      await handleSubmitted(values, item, apiCreate, apiUpdate, apiDelete);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={4}>
            <StringTextField
              label="Tên khóa"
              name="nameField"
              formik={formik}
              hintValue={item.courseName}
            />
          </Grid>

          <Grid xs={12} md={4}>
            <StringTextField
              label="Mã khóa"
              name="codeField"
              formik={formik}
              hintValue={item.courseCode}
            />
          </Grid>

          {mdUp && ( // only render empty Grid on desktop
            <Grid xs={12} md={4} />
          )}

          <Grid xs={12} md={4}>
            <DateAndTimePicker
              label="Ngày khai giảng"
              name="openingField"
              formik={formik}
              hintValue={item.openingDay}
            />
          </Grid>

          <Grid xs={12} md={4}>
            <DateAndTimePicker
              label="Ngày bế giảng"
              name="closingField"
              formik={formik}
              hintValue={item.closingDay}
            />
          </Grid>

          <Grid xs={12} md={4}>
            <DateAndTimePicker
              label="Ngày hết hạn"
              name="expireField"
              formik={formik}
              hintValue={item.expireDay}
            />
          </Grid>

          {/* <Grid xs={12} md={4}>
            <DateAndTimePicker
              label="Ngày bắt đầu"
              name="startField"
              formik={formik}
              hintValue={item.startDay}
            />
          </Grid> */}

          <Grid xs={12} md={4}>
            <DropdownStatus
              label="Trạng thái"
              name="statusField"
              type="kh"
              hintValue={item.status}
              onSelected={(obj) => {
                formik.values.statusField = obj;
              }}
              disabled={myId === 0}
            />
          </Grid>

          <Grid xs={12} md={11} display="flex" 
              sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
            >
            <SubmitButton formik={formik} isRemove={ item.quantity === 0 } />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
};
